<ng-container *ngFor="let sampleType of payload.missingInformationBySampleType | keyvalue">

    <div class="specimen-header">
        <div class="specimen-name">
            <ng-container >
                <ng-container [ngSwitch]="sampleType.key.toLowerCase()">
                    <span *ngSwitchCase="'tumor'">{{'Tumor specimen information' | stringTranslate}}</span>
                    <span *ngSwitchCase="'normal'">{{'Normal specimen information' | stringTranslate}}</span>
                </ng-container>
            </ng-container>
        </div>
    </div>

    <ng-container *ngFor="let item of sampleType.value">
        <div class="Flexbox dynamic-form-item-label-wrapper" [ngClass]="item.attributes && item.attributes.labelWrapperCss || ''">
            <label *ngIf="!item.labelExt" class="dynamic-form-item-label form-label-12-rem"
                   [ngClass]="item.attributes && item.attributes.labelCss || ''">
                {{item.label | stringTranslate}}
            </label>
        </div>
    </ng-container>
</ng-container>